import { render, staticRenderFns } from "./elem-table.vue?vue&type=template&id=d3c27eba&"
import script from "./elem-table.vue?vue&type=script&lang=js&"
export * from "./elem-table.vue?vue&type=script&lang=js&"
import style0 from "./elem-table.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports